import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AidtKerisApi_GetUserIdsQueryVariables = Types.Exact<{
  input: Types.AidtUserMapInput;
}>;


export type AidtKerisApi_GetUserIdsQuery = { __typename?: 'Query', aidtUserMap: { __typename?: 'AidtUserMapPayload', aidtUserMap: Array<{ __typename?: 'AidtUserMapObject', aidtUserId: string, userId: string }> } };

export type AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AidtKerisApi_GetGroup_LectureCode_StudentQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, groups: Array<{ __typename?: 'Group', id: string, aidtLecture?: { __typename?: 'AidtLecture', id: string, lectureCode: string } | null }> } | null };

export type AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AidtKerisApi_GetGroup_LectureCode_TeacherQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, manager: { __typename?: 'Manager', id: string, groups: Array<{ __typename?: 'Group', id: string, aidtLecture?: { __typename?: 'AidtLecture', id: string, lectureCode: string } | null }> } } | null };


export const AidtKerisApi_GetUserIdsDocument = gql`
    query AIDTKerisAPI_GetUserIds($input: AidtUserMapInput!) {
  aidtUserMap(input: $input) {
    aidtUserMap {
      aidtUserId
      userId
    }
  }
}
    `;

/**
 * __useAidtKerisApi_GetUserIdsQuery__
 *
 * To run a query within a React component, call `useAidtKerisApi_GetUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAidtKerisApi_GetUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAidtKerisApi_GetUserIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAidtKerisApi_GetUserIdsQuery(baseOptions: Apollo.QueryHookOptions<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables> & ({ variables: AidtKerisApi_GetUserIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables>(AidtKerisApi_GetUserIdsDocument, options);
      }
export function useAidtKerisApi_GetUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables>(AidtKerisApi_GetUserIdsDocument, options);
        }
export function useAidtKerisApi_GetUserIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables>(AidtKerisApi_GetUserIdsDocument, options);
        }
export type AidtKerisApi_GetUserIdsQueryHookResult = ReturnType<typeof useAidtKerisApi_GetUserIdsQuery>;
export type AidtKerisApi_GetUserIdsLazyQueryHookResult = ReturnType<typeof useAidtKerisApi_GetUserIdsLazyQuery>;
export type AidtKerisApi_GetUserIdsSuspenseQueryHookResult = ReturnType<typeof useAidtKerisApi_GetUserIdsSuspenseQuery>;
export type AidtKerisApi_GetUserIdsQueryResult = Apollo.QueryResult<AidtKerisApi_GetUserIdsQuery, AidtKerisApi_GetUserIdsQueryVariables>;
export const AidtKerisApi_GetGroup_LectureCode_StudentDocument = gql`
    query AIDTKerisAPI_GetGroup_LectureCode_Student {
  me {
    id
    groups {
      id
      aidtLecture {
        id
        lectureCode
      }
    }
  }
}
    `;

/**
 * __useAidtKerisApi_GetGroup_LectureCode_StudentQuery__
 *
 * To run a query within a React component, call `useAidtKerisApi_GetGroup_LectureCode_StudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAidtKerisApi_GetGroup_LectureCode_StudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAidtKerisApi_GetGroup_LectureCode_StudentQuery({
 *   variables: {
 *   },
 * });
 */
export function useAidtKerisApi_GetGroup_LectureCode_StudentQuery(baseOptions?: Apollo.QueryHookOptions<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>(AidtKerisApi_GetGroup_LectureCode_StudentDocument, options);
      }
export function useAidtKerisApi_GetGroup_LectureCode_StudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>(AidtKerisApi_GetGroup_LectureCode_StudentDocument, options);
        }
export function useAidtKerisApi_GetGroup_LectureCode_StudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>(AidtKerisApi_GetGroup_LectureCode_StudentDocument, options);
        }
export type AidtKerisApi_GetGroup_LectureCode_StudentQueryHookResult = ReturnType<typeof useAidtKerisApi_GetGroup_LectureCode_StudentQuery>;
export type AidtKerisApi_GetGroup_LectureCode_StudentLazyQueryHookResult = ReturnType<typeof useAidtKerisApi_GetGroup_LectureCode_StudentLazyQuery>;
export type AidtKerisApi_GetGroup_LectureCode_StudentSuspenseQueryHookResult = ReturnType<typeof useAidtKerisApi_GetGroup_LectureCode_StudentSuspenseQuery>;
export type AidtKerisApi_GetGroup_LectureCode_StudentQueryResult = Apollo.QueryResult<AidtKerisApi_GetGroup_LectureCode_StudentQuery, AidtKerisApi_GetGroup_LectureCode_StudentQueryVariables>;
export const AidtKerisApi_GetGroup_LectureCode_TeacherDocument = gql`
    query AIDTKerisAPI_GetGroup_LectureCode_Teacher {
  me {
    id
    manager {
      id
      groups {
        id
        aidtLecture {
          id
          lectureCode
        }
      }
    }
  }
}
    `;

/**
 * __useAidtKerisApi_GetGroup_LectureCode_TeacherQuery__
 *
 * To run a query within a React component, call `useAidtKerisApi_GetGroup_LectureCode_TeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useAidtKerisApi_GetGroup_LectureCode_TeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAidtKerisApi_GetGroup_LectureCode_TeacherQuery({
 *   variables: {
 *   },
 * });
 */
export function useAidtKerisApi_GetGroup_LectureCode_TeacherQuery(baseOptions?: Apollo.QueryHookOptions<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>(AidtKerisApi_GetGroup_LectureCode_TeacherDocument, options);
      }
export function useAidtKerisApi_GetGroup_LectureCode_TeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>(AidtKerisApi_GetGroup_LectureCode_TeacherDocument, options);
        }
export function useAidtKerisApi_GetGroup_LectureCode_TeacherSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>(AidtKerisApi_GetGroup_LectureCode_TeacherDocument, options);
        }
export type AidtKerisApi_GetGroup_LectureCode_TeacherQueryHookResult = ReturnType<typeof useAidtKerisApi_GetGroup_LectureCode_TeacherQuery>;
export type AidtKerisApi_GetGroup_LectureCode_TeacherLazyQueryHookResult = ReturnType<typeof useAidtKerisApi_GetGroup_LectureCode_TeacherLazyQuery>;
export type AidtKerisApi_GetGroup_LectureCode_TeacherSuspenseQueryHookResult = ReturnType<typeof useAidtKerisApi_GetGroup_LectureCode_TeacherSuspenseQuery>;
export type AidtKerisApi_GetGroup_LectureCode_TeacherQueryResult = Apollo.QueryResult<AidtKerisApi_GetGroup_LectureCode_TeacherQuery, AidtKerisApi_GetGroup_LectureCode_TeacherQueryVariables>;
export const namedOperations = {
  Query: {
    AIDTKerisAPI_GetUserIds: 'AIDTKerisAPI_GetUserIds',
    AIDTKerisAPI_GetGroup_LectureCode_Student: 'AIDTKerisAPI_GetGroup_LectureCode_Student',
    AIDTKerisAPI_GetGroup_LectureCode_Teacher: 'AIDTKerisAPI_GetGroup_LectureCode_Teacher'
  }
}